import { render, staticRenderFns } from "./ReceivingAccountNumber.vue?vue&type=template&id=0f897286&scoped=true"
import script from "./ReceivingAccountNumber.vue?vue&type=script&lang=js"
export * from "./ReceivingAccountNumber.vue?vue&type=script&lang=js"
import style0 from "./ReceivingAccountNumber.vue?vue&type=style&index=0&id=0f897286&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f897286",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0f897286')) {
      api.createRecord('0f897286', component.options)
    } else {
      api.reload('0f897286', component.options)
    }
    module.hot.accept("./ReceivingAccountNumber.vue?vue&type=template&id=0f897286&scoped=true", function () {
      api.rerender('0f897286', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/appBasicSetup/components/ReceivingAccountNumber.vue"
export default component.exports